import { get, post } from '../Services/http';
import { catchError } from './Error.action';
import { showLoader, hideLoader } from './Loader.action';

export const MYQUOTES_RECEIVE = 'MYQUOTES_RECEIVE';
export const MYQUOTES_ERROR = 'MYQUOTES_ERROR';
export const MYQUOTES_CHANGE_MODE = 'MYQUOTES_CHANGE_MODE';
export const MYQUOTES_SET_QUOTE = 'MYQUOTES_SET_QUOTE';

export const MYQUOTEDETAIL_RECEIVE = 'MYQUOTES_RECEIVE';
export const MYQUOTEDETAIL_ERROR = 'MYQUOTES_ERROR';

export const changeMode = (mode) => ({
    type: MYQUOTES_CHANGE_MODE,
    payload: {
        mode,
    },
});

export const receive = (data) => ({
    type: MYQUOTES_RECEIVE,
    payload: {
        myQuotesList: data,
    },
});

export const setError = error => ({
    type: MYQUOTES_ERROR,
    payload: {
        error,
    },
});

export const receiveQuoteDetail = (data) => ({
    type: MYQUOTEDETAIL_RECEIVE,
    payload: {
        selectedQuoteDetail: data,
    },
});

export const setErrorQuoteDetail = (data) => ({
    type: MYQUOTEDETAIL_ERROR,
    payload: {
        error,
    },
});


export const getMyQuotes = (fromDate, toDate) => (dispatch) => {
    dispatch(showLoader());
    return get('api/sales/quotes?fromDate=' + fromDate + '&toDate=' + toDate)
        .then(response => response.json())
        .then((result) => {
            dispatch(receive(result));
            dispatch(changeMode('list'));
            dispatch(hideLoader());
        })
        .catch((ex) => dispatch(catchError(ex, (error) => setError(error))));
};

export const getMyQuoteDetail = (quoteNumber) => (dispatch) => {
    dispatch(showLoader());
    // quoteNumber = "LS10129";
    return get('api/sales/quotes/' + quoteNumber)
        .then(response => response.json())
        .then((result) => {
            dispatch(receiveQuoteDetail(result));
            dispatch(hideLoader());
        })
        .catch((ex) => dispatch(catchError(ex, (error) => setErrorQuoteDetail(error))));
};

export const savePO = (quoteNumber, poNumber) => (
    dispatch
    ) => {
        return post(`/api/sales/quotes/savePO?quoteNumber=${quoteNumber}&poNumber=${poNumber}`)
            .then((response) => response.json())
            .then((result) => dispatch(getMyQuoteDetail(quoteNumber)))
            .catch((ex) => dispatch(catchError(ex, (error) => setError(error))));
    };

export const saveJobName = (quoteNumber, jobName) => (
    dispatch
    ) => {
        return post(`/api/sales/quotes/saveJobName?quoteNumber=${quoteNumber}&jobName=${jobName}`)
            .then((response) => response.json())
            .then((result) => dispatch(getMyQuoteDetail(quoteNumber)))
            .catch((ex) => dispatch(catchError(ex, (error) => setError(error))));
    };

    
export const cancelOrder = (quoteNumber) => (
    dispatch
    ) => {
        return post(`/api/sales/quotes/cancel?quoteNumber=${quoteNumber}`)
            .then((response) => response.json())
            .then((result) => dispatch(getMyQuoteDetail(quoteNumber)))
            .catch((ex) => dispatch(catchError(ex, (error) => setError(error))));
    };

export const approveOrder = (quoteNumber) => (
    dispatch
    ) => {
        return post(`/api/sales/quotes/approve?quoteNumber=${quoteNumber}`)
            .then((response) => response.json())
            .then((result) => dispatch(getMyQuoteDetail(quoteNumber)))
            .catch((ex) => dispatch(catchError(ex, (error) => setError(error))));
    };